import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import {AuthService} from '../../services/auth.service'
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit , OnDestroy{

  constructor(public auth:AuthService, private router : Router,public common:CommonService, public firebaseService : FirebaseService) { }
  // display : boolean = true
  country
  width_modal
  offer
  
  ngOnInit(): void {
    // //console.log(screen.width)
    if(screen.width>960){
      this.width_modal = '40vw'
    }
    else{
      this.width_modal = '75vw'
    }
    if(this.auth.isAuthenticated()){
        this.router.navigateByUrl('/dashboard')
    }
    this.common.showBackButton = false 
    this.common.getOffers().subscribe(res => {
      this.offer = res
    })   
  }

  onSignIn(signInForm){
    if(signInForm.valid){
      this.auth.signin(signInForm.value.email,signInForm.value.password)
    }
  }

  showPassword(e){
    if(e.target.previousSibling.getAttribute('type') == 'password'){
      e.target.previousSibling.setAttribute('type','text')
      e.target.classList.replace('fa-eye', 'fa-eye-slash')
    }
    else{
      e.target.previousSibling.setAttribute('type','password')
      e.target.classList.replace('fa-eye-slash', 'fa-eye')
    }
  }

  setCountryId(val){
    //console.log(val)
    this.firebaseService.country_id = val
    this.firebaseService.get_country_id = false

    this.firebaseService.proceedWithFirebaseLogin()
  }

  ngOnDestroy(){
    this.common.showBackButton = true
  }

  
}
